import React from "react";

const DampGhosts = () => {
    return (
        <div>
            <h1>Where the Ghosts Are Damp</h1>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/WC4IrrwXfjM?si=OWwwC81k0RfIkIeF"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen></iframe>

            <a href="https://store.steampowered.com/app/3270590/Where_the_Ghosts_Are_Damp/">Steam Page</a>

            <p>In this surreal puzzle adventure, a historic flood sweeps through Moko valley. Everything is in chaos.
                Infrastructure? Ruined. Trust? Fragile. And for some reason, ghost cats are now stealing the last
                remaining emergency supplies. You volunteer to help. How hard could it be?
            </p>
        </div>
    )
        ;
};

export default DampGhosts;
